import styled from "@emotion/styled";

export const Label = styled.label`
  font-weight: 600;
`;
